import { useEffect } from 'react';
import { useToast } from '@opaz/ui-components';
import { useNavigate } from '@tanstack/react-router';
import { setToastFunction, setNavigateFunction } from '@/services/backend/http-client';
import { ExternalToast } from 'sonner';

export const ApiErrorHandler = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    // Create a wrapper function to match the expected signature
    const wrappedToast = (params: { message: string; variant: 'success' | 'destructive'; options?: ExternalToast }) => {
      toast({
        message: params.message,
        variant: params.variant,
        options: params.options,
      });
    };

    setToastFunction(wrappedToast);
    setNavigateFunction(navigate);
  }, [toast, navigate]);

  return null;
};
